/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import { IconFile, IconArchive, IconTrash, IconArrowRight, IconArrowLeft, IconTemplate, IconUsers } from '@tabler/icons-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Divider,Tooltip,ActionIcon } from '@mantine/core';

const data = [
  { link: '', label: 'My Forms', icon: IconFile },
  { link: '', label: 'Templates', icon: IconTemplate},
  { link: '', label: 'Shared With Me', icon: IconUsers },
  { link: '', label: 'Trash', icon: IconTrash },
  { link: '', label: 'Archive', icon: IconArchive },
];

export default function Navbar({setNavItem, setTemplateOpen, navItem}) { // Add navItem as prop
  const [active, setActive] = useState('My Forms');
  const [isCollapse, setIsCollapse] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const HoverableNavItem = ({ item, isActive, isCollapse, handleClick }) => {
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <a
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => handleClick(item)}
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '10px',
        justifyContent: isCollapse ? 'center' : '',
        color: isActive ? 'white' : isHovered ? '#000000ff' : 'black',
        textDecoration: 'none',
        backgroundColor: isActive
          ? '#1ab394'
          : isHovered
          ? 'rgba(26, 179, 148, 0.08)'
          : 'transparent',
        fontWeight: isActive ? 'bold' : 'normal',
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',
      }}
    >
      <item.icon
        style={{
          marginRight: isCollapse ? '0' : '10px',
          transition: 'transform 0.2s ease-in-out',
          transform: isHovered ? 'scale(1.1)' : 'scale(1)',
        }}
        stroke={1.5}
      />
      {!isCollapse && <span>{item.label}</span>}
    </a>
  );
};

  // Sync active state with navItem prop when it changes
  useEffect(() => {
    if (navItem && navItem !== active) {
      setActive(navItem);
    }
  }, [navItem, active]);

  // Also sync with location state if it exists
  useEffect(() => {
    if (location.state?.navItem) {
      setActive(location.state.navItem);
      setNavItem(location.state.navItem);
    }
  }, [location.state, setNavItem]);

  const handleLinkClick = (item) => {
    setActive(item.label);
    setNavItem(item.label);
    if (item.link) {
      navigate(item.link);
    }
  };

  return (
   <div style={{ minHeight: '100vh', display: 'flex' }}>
  <aside
    style={{
      width: isCollapse ? '5rem' : '16rem',
      background: 'linear-gradient(180deg, #f9f9f9 0%, #c2f0e1 100%)',//e6f9f4
      borderRight: '1px solid rgba(0,0,0,0.1)',
      boxShadow: '2px 0 8px rgba(0,0,0,0.05)',
      transition: 'width 0.25s ease-in-out',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    }}
  >
    <nav style={{ padding: 0 }}>
      <Container
        size="xl"
        h="40"
        mr="0"
        ml="0"
        fluid
        styles={{
          root: {
            textAlign: isCollapse ? 'center' : 'end',
          },
        }}>
      <a
        style={{
          display: 'flex',
          justifyContent: isCollapse ? 'center' : 'space-between',
          cursor: 'pointer',
          fontWeight: 900,
          fontSize: '1.5rem',
          margin: '7px',
        }}
      >
        {!isCollapse && <span>Welcome</span>}
        <Tooltip
              //label={isCollapse ? "Expand Navbar" : "Collapse Navbar"}
              disabled
              position="bottom"
              withArrow
              styles={{
                  border: 'none', 
              }}
            >
          <ActionIcon
            variant="filled"
            size="lg"
            bg= '#f9f9f9'
            c= '#1ab394'
            style={{
              border: 'none',
              outline: 'none',
              boxShadow: 'none',
              transition: 'all 0.2s ease',
            }}
            onClick={() => setIsCollapse(!isCollapse)}
          >
            {isCollapse ? (
              <IconArrowRight stroke={2} />
            ) : (
              <IconArrowLeft stroke={2} />
            )}
          </ActionIcon>
        </Tooltip>
      </a>
    </Container>



      <div style={{ display: 'flex', flexDirection: 'column', marginTop: '0.25rem' }}>
        {data.map((item) => (
          <Container
            key={item.label}
            styles={{
              root: {
                margin: isCollapse ? 'auto' : '0',
                textAlign: isCollapse ? 'center' : 'start',
                alignItems: isCollapse ? 'center' : 'start',
              },
            }}
            m={0}
            p={0}
            fluid
          >
            <HoverableNavItem
              item={item}
              isActive={item.label === active}
              isCollapse={isCollapse}
              handleClick={handleLinkClick}
            />
          </Container>
        ))}
      </div>
    </nav>
  </aside>
</div>

  );
}